import { render, staticRenderFns } from "./SubscriptionResumeDialog.vue?vue&type=template&id=516c756c"
import script from "./SubscriptionResumeDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionResumeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports